import { Card, CardContent, CardHeader } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'

export function CheckoutPageSkeleton() {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-[minmax(0,1fr)_360px] gap-6">
        <Card className="gap-0 py-0">
          <CardHeader className="border-b py-4">
            <Skeleton className="h-7 w-48" />
            <Skeleton className="mt-1 h-4 w-72" />
          </CardHeader>
          <CardContent className="space-y-4 py-4">
            <div className="flex flex-wrap gap-4">
              <Skeleton className="h-10 w-72" />
              <Skeleton className="h-10 w-40" />
              <Skeleton className="h-10 w-40" />
            </div>

            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4">
              {Array.from({ length: 8 }).map((_, index) => (
                <div key={index} className="rounded-lg border bg-card p-4">
                  <Skeleton className="h-4 w-3/4" />
                  <Skeleton className="mt-2 h-3 w-1/2" />
                  <Skeleton className="mt-4 h-20 w-full" />
                  <Skeleton className="mt-4 h-9 w-full" />
                </div>
              ))}
            </div>
          </CardContent>
        </Card>

        <Card className="gap-0 py-0">
          <CardHeader className="border-b py-4">
            <Skeleton className="h-6 w-32" />
          </CardHeader>
          <CardContent className="space-y-4 py-4">
            {Array.from({ length: 4 }).map((_, index) => (
              <Skeleton key={index} className="h-14 w-full" />
            ))}
            <Skeleton className="h-10 w-full" />
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
